import script from "./Sidebarv3.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebarv3.vue?vue&type=script&setup=true&lang=js"

import "./Sidebarv3.vue?vue&type=style&index=0&id=02fbdb28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02fbdb28"]])

export default __exports__